import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { BreadcrumbProps } from "../types";

function Breadcrumb({ className, ...props }: BreadcrumbProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <nav
      data-slot="breadcrumb"
      className={cn(className, classes)}
      aria-label="breadcrumb"
      {...native}
    />
  );
}

Breadcrumb.displayName = "Breadcrumb";

export default Breadcrumb;
